const doc = [({"zh_tw":({"adminConstantPromotionDiscountType":({"fixed":"固定的", "percent":"比率"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;